module.exports = {"title":"Artists","showMore":"Show more","showLess":"Show less","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Stream/StreamArtistsModal/locales/en.json
// module id = 1809
// module chunks = 0